import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const SignatureBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();

  const heading = block.settings.headingOverride || "Signature";
  const label = block.settings.signatureLabel || "Authorized Signature";
  const showName = block.settings.signatureShowName !== false;
  const showDate = block.settings.signatureShowDate !== false;

  const clientName = state.client?.displayName || "";
  const today = new Date().toLocaleDateString("en-CA");

  return (
    <div className="py-6 mt-4">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-4">
        {heading}
      </p>

      <div className="max-w-sm">
        {/* Signature line */}
        <div className="min-h-[40px] border-b-2 border-slate-800 flex items-end pb-1">
          <span className="text-lg text-slate-400 select-none leading-none">X</span>
        </div>
        <p className="text-xs uppercase tracking-wide text-slate-500 mt-1">{label}</p>

        {/* Printed name */}
        {showName && (
          <div className="mt-5">
            <div className="min-h-[24px] border-b border-slate-400 flex items-end pb-1">
              <span className="text-sm text-slate-700">{clientName}</span>
            </div>
            <p className="text-xs uppercase tracking-wide text-slate-500 mt-1">Printed Name</p>
          </div>
        )}

        {/* Date */}
        {showDate && (
          <div className="mt-5">
            <div className="min-h-[24px] border-b border-slate-400 flex items-end pb-1">
              <span className="text-sm text-slate-700">{today}</span>
            </div>
            <p className="text-xs uppercase tracking-wide text-slate-500 mt-1">Date</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignatureBlock;
